// extracted by mini-css-extract-plugin
export default {"cards":"cards_cards__snLIo","card":"cards_card__mKr-D","num":"cards_num__I1n3r","heading":"cards_heading__wY0XT"};